import { render, staticRenderFns } from "./rightFixd.vue?vue&type=template&id=e29c7f4a&scoped=true"
import script from "./rightFixd.vue?vue&type=script&lang=js"
export * from "./rightFixd.vue?vue&type=script&lang=js"
import style0 from "./rightFixd.vue?vue&type=style&index=0&id=e29c7f4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29c7f4a",
  null
  
)

export default component.exports